import { localDate } from '@sales-center/common'
import { IPropertyFilter } from './IPropertyFilter'

export type DateRange = {
  matchType: 'lt' | 'gt' | 'bt'
  start: Date | null
  end: Date | null
}

export const isValidDateRange = ({
  matchType,
  start,
  end,
}: DateRange): boolean => {
  if (start === null) return false
  if (matchType === 'bt') {
    return end !== null
  }
  return true
}

export const deserializeDateRange = ({
  matchType,
  start,
  end,
}: {
  matchType: DateRange['matchType']
  start: string | null
  end: string | null
}): DateRange => {
  const startDate = start === null ? null : new Date(start)
  const endDate = end === null ? null : new Date(end)

  return {
    matchType,
    start: startDate,
    end: endDate,
  }
}

export interface IDateRangeFilter<T> extends IPropertyFilter<T> {
  type: 'dateRange'
  value: DateRange
}

export const isDateRangeFilter = <T>(
  filter: IPropertyFilter<T>,
): filter is IDateRangeFilter<T> => filter.type === 'dateRange'

export const normalizeDateRangeFilter = <T>({
  propertyName,
  value: { matchType, start, end },
}: IDateRangeFilter<T>): string => {
  const startDate = localDate(start)
  const endDate = localDate(end)

  if (!startDate) return ''
  if (matchType === 'bt' && !endDate) return ''

  const propertyNameStr = String(propertyName)

  switch (matchType) {
    case 'gt':
    case 'lt':
      return `(${propertyNameStr} ${matchType} ${startDate})`
    case 'bt':
      return `(${propertyNameStr} ge ${startDate} and ${propertyNameStr} le ${endDate})`
  }
}
